<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
  @switch (name) {
    @case ('question') {
      <path d="M5 4h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-8l-4 3v-3H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"/>
      <path d="M8 8.5h8M8 12h5"/>
    }
    @case ('search') {
      <circle cx="10.5" cy="10.5" r="6"/>
      <path d="M20 20l-5.25-5.25"/>
    }
    @case ('page') {
      <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
      <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z"/>
      <path d="M10 13l-2 2 2 2M14 13l2 2-2 2"/>
    }
    @case ('domain') {
      <circle cx="12" cy="12" r="9"/>
      <path d="M3.6 9h16.8M3.6 15h16.8M11.5 3a17 17 0 0 0 0 18M12.5 3a17 17 0 0 1 0 18"/>
    }
    @case ('request') {
      <path d="M4 6h8M16 6h4M4 12h2M10 12h10M4 18h11M19 18h1"/>
      <circle cx="14" cy="6" r="2"/>
      <circle cx="8" cy="12" r="2"/>
      <circle cx="17" cy="18" r="2"/>
    }
    @case ('access') {
      <circle cx="8" cy="15" r="4"/>
      <path d="M10.85 12.15L19 4M18 5l2 2M15 8l2 2"/>
    }
    @case ('response') {
      <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
      <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z"/>
      <path d="M9 13h6M9 17h4"/>
    }
  }
</svg>
